import { Component } from '@angular/core';
import { ConsultantsService } from '../../shared/services/consultants.service';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { AuthService } from '../../auth/auth.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ConsultantDetailsComponent } from '../consultant-details/consultant-details.component';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';

@Component({
  selector: 'app-consultant-list',
  templateUrl: './consultant-list.component.html',
  styleUrls: ['./consultant-list.component.scss']
})
export class ConsultantListComponent {

  consultants: any[] = [];
  resultsLength: number = 0;
  isLoadingResults: boolean = false;
  faPlus = faPlus;

  lastRequest?: TableSearchRequest;

  columns: TableColumn[] = [
    { key: 'name',        label: 'Name',         sortable: true, filterable: true },
    { key: 'emailAddress',label: 'Email',        sortable: true, filterable: true },
    { key: 'postcode',    label: 'Postcode',      sortable: true, filterable: true },
    { key: 'phoneNumber', label: 'Phone Number',  sortable: true, filterable: true },
    { key: 'fees',        label: 'Fees',          sortable: true },
    { key: 'active', label: 'Is Active', sortable: true, filterable: true, filterType: 'select',
        filterOptions: [
          { label: 'Yes', value: '{{bool}}true' },
          { label: 'No',  value: '{{bool}}false' }
        ]
      }
  ];

  constructor(
    private consultantsService: ConsultantsService,
    public authService: AuthService,
    public modalService: ModalService) {
  }
  

  onSearch(request: TableSearchRequest) {
    this.lastRequest = request;
    this.isLoadingResults = true;
    this.consultantsService.getConsultants(request).subscribe({
      next: data => {
        this.consultants = data.items;
        this.resultsLength = data.recordCount;
        this.isLoadingResults = false;
      },
      error: () => this.isLoadingResults = false
    });
  }

  addConsultant() {
    const modalRef = this.modalService.openWithOptions(ConsultantDetailsComponent, { size: 'lg', scrollable: true });
    modalRef.result.then(
      (result) => { if (result) this.reload(); },
      () => {}
    );
  }

  editConsultant(consultant: any) {
    const modalRef = this.modalService.openWithOptions(ConsultantDetailsComponent, { size: 'lg', scrollable: true });
    modalRef.componentInstance.consultantId = consultant.id;
    modalRef.result.then(
      (result) => { if (result) this.reload(); },
      () => {}
    );
  }

  private reload() {
  if (this.lastRequest) {
    this.onSearch(this.lastRequest);
  }
}
}